import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { push } from 'connected-react-router'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { get } from 'lodash'
import { FormattedMessage } from 'react-intl'
import queryString from 'query-string'

import { LayoutPlain, Header, Footer } from 'components/layout'
import { MaterialLoader } from 'components/loaders'
import { Button } from 'components/misc'
import { Textarea } from 'components/fields'
import { apiAssessors, apiCommon } from 'helpers/decorators/api'
import { logError } from 'redux/modules/app'
import { meta, form } from 'helpers/decorators'
import config from 'config'

@meta({
  title: 'Registration reject',
  intlKey: 'pageTitle.registration_reject'
})
@apiAssessors()
@apiCommon()
@connect(null, {
  logError,
  push
})
@form({
  form: 'reject-assessor-registration',
  disableHook: true
})
class AssessorRejection extends Component {
  static propTypes = {
    onRejectAssessorInvitation: PropTypes.func,
    logError: PropTypes.func,
    push: PropTypes.func,
    handleSubmit: PropTypes.func,
    isValidAuthCode: PropTypes.func,
    location: PropTypes.object
  }

  state = {
    isLoading: true
  }

  componentDidMount = () => {
    const { isValidAuthCode } = this.props

    isValidAuthCode(this.getAuthCode())
      .then(({ body } = {}) => {
        this.setState({
          isLoading: false
        })
        if (get(body, 'value') === false) {
          this.handleCodeNotValid()
        }
      })
      .catch(() => {
        this.handleCodeNotValid()
      })
  }

  getAuthCode = () => {
    const query = queryString.parse(get(this.props, 'location.search'))

    return get(query, 'authorizationCode')
  }

  handleCodeNotValid = () => {
    this.props.logError({
      body: {
        errorCode: 'AUTH_CODE_NOT_FOUND'
      }
    })
    this.props.push(`${config.publicPath}/`)
  }

  handleReject = fields => {
    const { onRejectAssessorInvitation } = this.props

    this.setState({
      isLoading: true
    })
    onRejectAssessorInvitation(this.getAuthCode(), fields)
  }

  render() {
    const { location, handleSubmit } = this.props
    const { isLoading } = this.state

    const content = (
      <div>
        <h1>
          {isLoading && (
            <div>
              <MaterialLoader />{' '}
            </div>
          )}
          {!isLoading && (
            <FormattedMessage
              id="moduleTitle.rejecting_assessor_invitation"
              defaultMessage="Reject invitation to become assessor"
            />
          )}
        </h1>
        {!isLoading && (
          <div>
            <form onSubmit={handleSubmit(this.handleReject)}>
              <Textarea label="Reason" intlKey="label.reason" name="value" />
              <div className="text--center">
                <Button intlKey="button.reject_invitation">
                  Reject invitation
                </Button>
              </div>
            </form>

            <div className="text--center" style={{ marginTop: 20 }}>
              <Link
                className="link"
                to={`${config.publicPath}/register/assessor/${get(location, 'search')}`}
              >
                <FormattedMessage
                  id="label.accept_invitation_and_continue"
                  defaultMessage="Accept invitation and continue to registration"
                />
              </Link>
            </div>
          </div>
        )}
      </div>
    )

    return (
      <LayoutPlain header={<Header />} footer={<Footer />} body={[content]} />
    )
  }
}

export default AssessorRejection
